export default {
  getReviewRuleGoodsPage: {
    url: '/requestReview/getReviewRuleGoodsPage',
    method: 'post',
    desc: '获取商品列表'
  },
  getRequestReviewPage: {
    url: '/requestReview/page',
    method: 'post',
    desc: '请求评论规则分页'
  },
  deleteRule: {
    url: '/requestReview/deleteRule',
    method: 'post',
    desc: '删除规则'
  },
  addOrUpdateRule: {
    url: '/requestReview/addOrUpdateRule',
    method: 'post',
    desc: '新增更新规则'
  },
  getRule: {
    url: '/requestReview/getRule',
    method: 'post',
    desc: '获取规则'
  },
  getReviewRequestOrderPage: {
    url: '/requestReview/getReviewRequestOrderPage',
    method: 'post',
    desc: '请求记录分页'
  },
  updateStatus: {
    url: '/requestReview/updateStatus',
    method: 'post',
    desc: '批量启用停用'
  },
  retryRequest: {
    url: '/requestReview/retryRequest',
    method: 'post',
    desc: '批量重试'
  },
  getReviewRuleOrderPage: {
    url: '/requestReview/getReviewRuleOrderPage',
    method: 'post',
    desc: '获取订单列表'
  },
  getReviewRuleBuyerPage: {
    url: '/requestReview/getReviewRuleBuyerPage',
    method: 'post',
    desc: '获取买家列表'
  },
  getPendingReviewRequestOrderPage: {
    url: '/requestReview/getPendingReviewRequestOrderPage',
    method: 'post',
    desc: '待请求记录分页'
  },
  ignoreOrder: {
    url: '/requestReview/ignoreOrder',
    method: 'post',
    desc: '忽略待请求订单'
  },
  getReviewReport: {
    url: '/requestReview/getReviewReport',
    method: 'post',
    desc: '分析弹框'
  },
}
